import {HivesHead, HivesTable} from 'features/hives';
import {useGlobalStore} from 'entities/global';
import {useEffect} from 'react';
import {useHivesStore} from 'entities/hives';
import {ApiaryHivesAbsence} from '../../../shared/ui/apiaryHivesAbsence/ApiaryHivesAbsence.tsx';

export const Hives = () => {
  const setPlusButton = useGlobalStore((s) => s.setPlusButtonCallback);
  const openPopup = useHivesStore((s) => s.managePopup);

  useEffect(() => {
    setPlusButton(() => openPopup(true));

    return () => {
      setPlusButton(null);
    };
  });

  return (
    <div>
      <HivesHead />
      <ApiaryHivesAbsence>
        <HivesTable />
      </ApiaryHivesAbsence>
    </div>
  );
};
